import { render, staticRenderFns } from "./markingRecord.vue?vue&type=template&id=0f965501&"
import script from "./markingRecord.vue?vue&type=script&lang=js&"
export * from "./markingRecord.vue?vue&type=script&lang=js&"
import style0 from "./markingRecord.vue?vue&type=style&index=0&id=0f965501&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports